// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invitePlayersModal_users__1OOUk {\n  margin-top: 30px;\n  height: 30vh;\n  overflow-y: auto;\n}\n\n.invitePlayersModal_inviteModal__2v_YA {\n  width: 400px;\n}\n.invitePlayersModal_inviteModal__2v_YA footer {\n  padding: 0 60px;\n  height: 92px;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.invitePlayersModal_inviteAll__1UJ0r {\n  background: var(--primary-dark);\n  display: block;\n  padding: 5px;\n  width: 100%;\n  text-transform: uppercase;\n  cursor: pointer;\n}", ""]);
// Exports
exports.locals = {
	"users": "invitePlayersModal_users__1OOUk",
	"inviteModal": "invitePlayersModal_inviteModal__2v_YA",
	"inviteAll": "invitePlayersModal_inviteAll__1UJ0r"
};
module.exports = exports;
